import {Pinecast} from '@pinecast/common/icons';
import {PageTitle} from '@pinecast/common/Text';
import {defineMessages, FormattedMessage} from '@pinecast/i18n';

const messages = defineMessages({
  heading: {
    id: 'tj-spa.SubscriptionPageHeader.heading',
    description: 'Heading for the subscriptions page in the tip jar',
    defaultMessage: 'Your podcast contributions',
  },
});

const SubscriptionPageHeader = () => {
  return (
    <>
      <PageTitle style={{marginTop: '16px'}}>
        <Pinecast size={48} style={{display: 'block'}} />
        <FormattedMessage {...messages.heading} />
      </PageTitle>
    </>
  );
};

export default SubscriptionPageHeader;
